const attachmentFilesEquipmentModelsBtn = {
  label: 'ADICIONAR'
};

export default attachmentFilesEquipmentModelsBtn;
